export enum AlertTypes {
    success = 'success',
    error = 'error',
    warning = 'warning',
    info = 'info',
    clear = 'clear',
    default = 'default'
}
